import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_ToggleButton, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.CLASS) ?? '']: true }),
        name: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ToogleButtonTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ToogleButtonTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.PLACEHOLDER),
        onLabel: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.ONLABEL),
        offLabel: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.OFFLABEL),
        iconPos: _ctx.getCatalogValue(_ctx.ToogleButtonTypeConst.ICONPOS),
        tabindex: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.TABINDEX),
        onIcon: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.ONICON),
        offIcon: _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.OFFICON),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.processEventComponent(_ctx.CatalogEventConst.CHANGE)))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "onLabel", "offLabel", "iconPos", "tabindex", "onIcon", "offIcon", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ToogleButtonTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}